<template>
  <div class="nav">
    <div class="parentx">
      <div>
        <vs-button
          @click="active=!active"
          icon="menu"
          type="filled"
          class="button"
        >
          MENU
        </vs-button>
      </div>

      <vs-sidebar color="primary" spacer v-model="active" hidden-background class="sidebarx">
        <Logo />
        <vs-sidebar-group
          open
          v-show="item.rule ? $acl.check(item.rule) : true"
          v-for="(item, index) in navMenuItems"
          :key="index"
          :title="item.header"
        >
          <div class="vs-group">
            <ul>
              <li
                v-for = "(submenu, indexSB) in item.submenu"
                v-show="submenu.rule ? $acl.check(submenu.rule) : true"
                :key = "indexSB"
              >
                <div style="display: flex;">
                  <span style="font-size: 13.5px; color: #9B0E1C; margin-top: 0.85px; margin-right: 5px;" class="material-icons">
                    {{submenu.icon}}
                  </span>
                  <a @click="goTo(submenu.url)" class="pointer">
                    {{submenu.title}}
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </vs-sidebar-group>

        <div class="footer-sidebar" slot="footer">
          <Panel/>
          <vs-button icon="reply" color="danger" type="flat" class="buttonFooter" @click="logout()">SAIR</vs-button>
        </div>
      </vs-sidebar>
    </div>

    <div class="title title-sidebar">
      <h3>Sistema de Matrícula - QI</h3>
    </div>
  </div>
</template>

<script>
import Logo from "@/components/Dashboard/Logo.vue"
import Panel from "@/components/Dashboard/Panel.vue"
import navMenuItems from "@/components/Dashboard/navMenuItems.js";
import { logoffUserAndEraseData } from '../../helpers/storage'

export default {
  name: "NavBar",
  data() {
    return {
      navMenuItems,
      active: false,
    }
  },

  components:{
    Logo,
    Panel
  },

  methods: {
    goTo(route) {
      this.$router.push(route);
    },

    logout() {
      logoffUserAndEraseData()
      this.$acl.change('public')
      this.$router.push('/login')
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: black;
}

ul {
  margin-bottom: -1em !important;
  list-style-type: none;
}

.parentx {
  visibility: hidden;
}

.titleQi {
  color: white;
}
.nav {
  z-index: 3;
  height: 3.125em;
  width: 100%;
  background-color: #9b0e1c;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
}

.button {
  margin-left: 1em;
}

.title {
  margin-right: 1em;
  color: white;
}

.vs-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 1.85px;
}

.vs-item {
  margin: -10px;
}

.header-sidebar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
}

.drop-menu {
  z-index: -1;
}

h4 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.footer-sidebar {
  display: grid;
  width: 100%;
}

.buttonFooter,
.buttonFooter:hover {
  background: #9B0E1C !important;
  color: white;
  font-weight: bold;
  border: 0px solid rgba(0,0,0,0) !important;
  border-left: 1px solid rgba(0,0,0,.07) !important;
  border-radius: 0px !important;
  width: 100%;
}

@media screen and (max-width: 790px) {
  .parentx {
    visibility: visible;
  }
  .nav {
    position: unset;
  }
}
</style>
